<template>
  <p class="error--text mt-1" :style="errorMessageStyles">
    <slot></slot>
  </p>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "constants/theme"

export default defineComponent({
  name: "ErrorText",
  props: {},
  setup() {
    return {
      errorMessageStyles: {
        ...THEME.typography.inputMessage,
      },
    }
  },
})
</script>
